import { render } from "./LojaSkeleton.vue?vue&type=template&id=ca1b73fe"
import script from "./LojaSkeleton.vue?vue&type=script&lang=js"
export * from "./LojaSkeleton.vue?vue&type=script&lang=js"
script.render = render

export default script